import React, { useEffect, useState, useCallback } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, FlatList, Platform } from 'react-native';
import TopGreenHeader from '../Common/TopGreenHeader';
import { useNavigation, useFocusEffect } from '@react-navigation/native';
import { useDispatch, useSelector } from 'react-redux';
import { loginActions } from '../../slices/authSlice';
import { toTitleCase } from '../Common/helper';
import { getAllAddressApi } from '../../apiCalls/LoginApi';

const AddressSelector = () => {
  const serviceDetail = useSelector(state => state.auth.serviceScheduled)
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const allAdress = useSelector(state => state.auth.getAllAdress)
  const [addresses, setAddresses] = useState([]);
  console.log("we are here");

  useFocusEffect(
    useCallback(() => {
      const fetchAddresses = async () => {
        const response = await getAllAddressApi();
        setAddresses(response?.Data)
      }
      fetchAddresses();
    }, [])
  )

  // useEffect(() => {
  //   setAddresses(allAdress?.Data)
  // }, [allAdress])

  const handleAddNewAddress = () => {
    navigation.navigate('AddAddress');
  };

  const handleSelectAddress = item => {
    const selectedAddressname = `${toTitleCase(item.tag)} - ${item.houseno}, ${toTitleCase(item.area)}, ${toTitleCase(item.city)}, ${item.zipcode}`
    if (serviceDetail.service == 'At Home Care') {
      dispatch(loginActions.resetAddress());
      dispatch(loginActions.selectedAddress(item))
      navigation.navigate('ConfirmBooking')
    } else {
      dispatch(loginActions.selectedAddress(item))
      navigation.navigate('SelectTransport')
    }
  };


  return (
    <>
      <TopGreenHeader
        Heading={'Select Address'}
        navigation={navigation}
        isBackIcon={true}
        isNotification={false}
      />
      <View style={styles.container}>
        {/* <Text style={styles.title}>Select Address</Text> */}
        <FlatList
          data={addresses}
          keyExtractor={(item) => item.id.toString()}
          renderItem={({ item }) => (
            <TouchableOpacity
              style={styles.addressItem}
              onPress={() => handleSelectAddress(item)}
            >
              <Text style={styles.addressText}>
                {`${toTitleCase(item.tag)} - ${item.houseno ? item.houseno + ',' : ''} ${toTitleCase(item.area)}, ${toTitleCase(item.city)}, ${item.zipcode}`}

              </Text>
            </TouchableOpacity>
          )}
        />

        <TouchableOpacity
          style={styles.addButton}
          onPress={handleAddNewAddress}>
          <Text style={styles.addButtonText}>Add New Address</Text>
        </TouchableOpacity>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    backgroundColor: '#fff',
  },
  title: {
    fontSize: 22,
    fontWeight: '600',
    marginBottom: 20,
    textAlign: 'center',
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: "normal",
  },
  addressItem: {
    paddingVertical: 15,
    borderBottomWidth: 1,
    borderColor: '#ccc',
  },
  addressText: {
    fontSize: 16,
    color: '#000',
    lineHeight: 20,
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
  },
  addButton: {
    backgroundColor: '#B3D335',
    paddingVertical: 15,
    alignItems: 'center',
    borderRadius: 5,
    marginTop: 30,
  },
  addButtonText: {
    color: '#fff',
    fontSize: 18,
    fontWeight: '600',
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: "normal",
  },
});

export default AddressSelector;
